import { useContext, useEffect, useState } from 'react';
import { ConversationsContext } from '../../../../context/ConversationsProvider';
import { ConversationsClientContext } from '../../../../context/ConversationsClientProvider';
import useViewer from '@hooks/useViewer';

const useMessagesUnread = () => {
    const { viewer } = useViewer();
    const { conversations } = useContext(ConversationsContext);
    const { conversationsClient } = useContext(ConversationsClientContext);
    const [unreadCount, setUnreadCount] = useState();

    useEffect(() => {
        if (!conversationsClient || !conversations || conversations.length === 0 || !viewer) return;
        (async () => {
            const getUnread = async () => {
                const promises = conversations.map(async convo => {
                    const unread = await convo.getUnreadMessagesCount();

                    if (unread !== null) {
                        return unread;
                    }

                    // if null, new conversation. Manually get message count from other participant
                    // because read horizon is not set
                    const messages = await convo.getMessages();
                    const promiseMessageTo = messages.items.filter(async message => {
                        const participant = await message.getParticipant();
                        return participant.state.identity !== viewer.id;
                    });
                    const messagesTo = await Promise.all(promiseMessageTo);
                    return messagesTo.length;
                });

                const allUnreadCounts = await Promise.all(promises);
                const allUnread = allUnreadCounts.reduce((prev, curr) => prev + curr);
                return allUnread;
            };

            const updateUnread = async () => {
                const allUnread = await getUnread();
                // set null if 0 so count doesn't show
                setUnreadCount(allUnread === 0 ? null : allUnread);
            };

            // this is semi-realtime
            // https://media.twiliocdn.com/sdk/js/conversations/releases/1.2.1/docs/Conversation.html#getUnreadMessagesCount__anchor
            setTimeout(async () => {
                updateUnread();
            }, 2000);
        })();
    }, [conversations, conversationsClient, viewer]);

    return unreadCount;
};

export default useMessagesUnread;
